import { Button } from '@/components/ui/elements/button';
import { Checkbox } from '@/components/ui/elements/checkbox';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/elements/dialog';
import { DialogProps } from '@radix-ui/react-dialog';
import { useState } from 'react';

type CancelEventDialogProps = DialogProps & {
  onSubmit: (sendEmail: boolean) => void;
};

export const CancelEventDialog = ({ onSubmit, ...props }: CancelEventDialogProps) => {
  const [sendEmail, setSendEmail] = useState(false);

  const handleSubmit = () => {
    onSubmit(sendEmail);
    if (props.onOpenChange) props.onOpenChange(false);
  };

  return (
    <Dialog {...props}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cancel this Event</DialogTitle>
          <DialogDescription>
            <span className="flex flex-row justify-start items-center py-4">
              <Checkbox
                defaultChecked={sendEmail}
                onCheckedChange={() => setSendEmail(!sendEmail)}
                className="mr-2"
              />
              <label>Send Cancellation Email?</label>
            </span>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="destructive" onClick={handleSubmit}>
            Yes, Cancel this event...
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
